/* src/components/UserAuthWrapper.js (FIXED) */
import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

/**
 * This component checks if a user is logged in.
 * If they are, it renders the nested child routes via the <Outlet /> component.
 * If not, it redirects them to the /login page.
 */
const UserAuthWrapper = () => {
    const location = useLocation();
    const token = localStorage.getItem('app_token');

    if (!token) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to. This allows us to send them back after login.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If the user is authenticated, render the nested child route components.
    return <Outlet />;
};

export default UserAuthWrapper;
